// NOTE: TanStack Query keys + list paging defaults for NodeShift Code.
export const CODE_SESSIONS_LIST_QUERY_KEY = "codeSessions";
export const CODE_SESSION_QUERY_KEY = "codeSession";
export const CODE_SESSION_EVENTS_QUERY_KEY = "codeSessionEvents";
export const CODE_REPOSITORIES_QUERY_KEY = "codeRepositories";
export const CODE_BRANCHES_QUERY_KEY = "codeBranches";

export const DEFAULT_CODE_SESSIONS_LIST_LIMIT = 20;
export const DEFAULT_CODE_SESSIONS_LIST_OFFSET = 0;

// NOTE: Page size for the session event log — equal to the server's
// CODE_SESSION_EVENTS_PAGE_LIMIT, which caps both the subscribeSession replay
// and the REST `/events` page. A page that comes back this full may have more
// behind it, so the client keeps paging with `afterSequence`. The server's
// code-session-events-page-limit.spec.ts reads this line and fails if the two
// drift, so keep it a plain numeric literal.
export const CODE_SESSION_EVENTS_PAGE_LIMIT = 1000;

// NOTE: Socket.IO namespace + event names for the code-sessions gateway.
// Mirrors apps/nsai/server/src/code-sessions/code-sessions.gateway.ts — the
// client emits subscribe/unsubscribe, the server emits replay + event.
export const CODE_SESSIONS_WS_NAMESPACE = "/api/code-sessions";

export const CODE_SESSION_WS_EVENTS = {
  subscribeSession: "subscribeSession",
  unsubscribeSession: "unsubscribeSession",
  replay: "replay",
  event: "event",
} as const;

// NOTE: Create-form validation patterns, mirrored by CreateCodeSessionDto on
// the server. They live here rather than inline in schema/code-session.ts so
// the mobile client can reuse them, per the repo's "scope-specific constants
// live in a constants/ folder" rule.
export const GITHUB_OWNER_PATTERN = /^[A-Za-z0-9](?:[A-Za-z0-9-]{0,38})$/;
export const GITHUB_REPO_PATTERN = /^[A-Za-z0-9._-]{1,100}$/;

// NOTE: A practical subset of git check-ref-format: no ASCII control chars,
// space, or any of ~^:?*[\; no leading or trailing "/" or "."; no "..",
// "@{", "//" or a ".lock" path component. Inputs are capped at
// BRANCH_MAX_LENGTH before this runs, so the lookaheads scan a bounded string.
/* eslint-disable no-control-regex -- rejecting the control range is the point:
   git forbids ASCII control characters in a ref name. */
export const GIT_BRANCH_PATTERN =
  /^(?!\/|\.)(?!.*(?:\.\.|@\{|\/\/|\.lock(?:\/|$)))[^\s~^:?*[\\\x00-\x1F\x7F]+(?<![/.])$/;
/* eslint-enable no-control-regex */

export const BRANCH_MAX_LENGTH = 255;
export const REPO_SEGMENT_MAX_LENGTH = 255;
export const PROMPT_MAX_LENGTH = 16000;
